import * as constants from '../constants';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.addExternalContamination.success:
        case constants.addInternalContamination.success: {
            return action.payload;
        }

        case constants.addExternalContamination.error:
        case constants.addInternalContamination.error: {
            return initialState;
        }

        case constants.addExternalContamination.try:
        case constants.addInternalContamination.try: {
            return {};
        }

        default:
            return state;
    }
}